import { render, staticRenderFns } from "./priceControlListComponent.vue?vue&type=template&id=679c7382&scoped=true&"
import script from "./priceControlListComponent.vue?vue&type=script&lang=js&"
export * from "./priceControlListComponent.vue?vue&type=script&lang=js&"
import style0 from "./priceControlListComponent.vue?vue&type=style&index=0&id=679c7382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679c7382",
  null
  
)

export default component.exports